/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Error_Arms_Too_Close12Inputs */

const en_us2_body_assessment_error_arms_too_close12 = /** @type {(inputs: Body_Assessment_Error_Arms_Too_Close12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your arms were touching your trunk. Hold them away in an A, a hand's width between elbow and waist: an arm against the trunk is read as waist.`)
};

const pt_br2_body_assessment_error_arms_too_close12 = /** @type {(inputs: Body_Assessment_Error_Arms_Too_Close12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os braços estavam encostados no tronco. Afaste os braços em forma de A, com um palmo entre o cotovelo e a cintura: braço encostado é lido como cintura.`)
};

const es_419_body_assessment_error_arms_too_close12 = /** @type {(inputs: Body_Assessment_Error_Arms_Too_Close12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus brazos tocaban el tronco. Sepáralos en forma de A, con un palmo entre el codo y la cintura: un brazo pegado al tronco se lee como cintura.`)
};

const pt_pt2_body_assessment_error_arms_too_close12 = /** @type {(inputs: Body_Assessment_Error_Arms_Too_Close12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os braços estavam encostados ao tronco. Afasta os braços em forma de A, com um palmo entre o cotovelo e a cintura: um braço encostado é lido como cintura.`)
};

const fr_fr2_body_assessment_error_arms_too_close12 = /** @type {(inputs: Body_Assessment_Error_Arms_Too_Close12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes bras touchaient ton tronc. Écarte-les en A, une main de largeur entre le coude et la taille : un bras collé au tronc est lu comme de la taille.`)
};

const de_de2_body_assessment_error_arms_too_close12 = /** @type {(inputs: Body_Assessment_Error_Arms_Too_Close12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Arme lagen am Rumpf an. Halte sie in A-Form weg, eine Handbreit zwischen Ellbogen und Taille: Ein Arm am Rumpf wird als Taille gelesen.`)
};

const it_it2_body_assessment_error_arms_too_close12 = /** @type {(inputs: Body_Assessment_Error_Arms_Too_Close12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le braccia toccavano il tronco. Tienile staccate ad A, con un palmo tra gomito e vita: un braccio attaccato al tronco viene letto come vita.`)
};

/**
* | output |
* | --- |
* | "Your arms were touching your trunk. Hold them away in an A, a hand's width between elbow and waist: an arm against the trunk is read as waist." |
*
* @param {Body_Assessment_Error_Arms_Too_Close12Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_error_arms_too_close12 = /** @type {((inputs?: Body_Assessment_Error_Arms_Too_Close12Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Error_Arms_Too_Close12Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_error_arms_too_close12(inputs)
	if (locale === "es-419") return es_419_body_assessment_error_arms_too_close12(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_error_arms_too_close12(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_error_arms_too_close12(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_error_arms_too_close12(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_error_arms_too_close12(inputs)
	return en_us2_body_assessment_error_arms_too_close12(inputs)
});
export { body_assessment_error_arms_too_close12 as "body-assessment.error.ARMS_TOO_CLOSE" }